import { render, staticRenderFns } from "./UpdateInfoModal.vue?vue&type=template&id=9c7445b2&scoped=true"
import script from "./UpdateInfoModal.vue?vue&type=script&lang=ts"
export * from "./UpdateInfoModal.vue?vue&type=script&lang=ts"
import style0 from "./UpdateInfoModal.vue?vue&type=style&index=0&id=9c7445b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7445b2",
  null
  
)

export default component.exports